import { useEffect, useState, useRef } from 'react';
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow, Breadcrumbs,
    CircularProgress, Link, IconButton
} from '@mui/material';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import axiosInstance from '../../../../lib/axios';
import { toast, Slide } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import { getRoomMasterdropdata } from '../../../../Api/PropertyMst/Api';
import { getShiftMasterdropdata } from '../../../../Api/PropertyMst/Api';
import AttendenceCalender from './AttendenceCalender';
import { selectGlobalProperty } from '../../../../redux/propertySlice';
import { useSelector } from 'react-redux';
import { usePermissions } from '../../../../GlobalFunction/userPermissions';
import moment from 'moment';

const Attendance = () => {
    const [formData, setFormData] = useState({
        Property: '',
        Shift: '',
        DateField: new Date().toISOString().split('T')[0]
    });
    const [calendarOpen, setCalendarOpen] = useState(false);

    const navigate = useNavigate();
    const [mode, setMode] = useState('view');
    const location = useLocation();
    const userId = sessionStorage.getItem('UserId');
    const [dropdownData, setDropdownData] = useState([]);
    const [shiftData, setShiftData] = useState([])
    const [fetchedData, setFetchedData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [showGrid, setShowGrid] = useState(false);
    const globalProperty = useSelector(selectGlobalProperty);
     const permissions = usePermissions("MP Attendance");
     const [isEditMode, setIsEditMode] = useState(false);
     const [isButtonDisabled, setIsButtonDisabled] = useState(false);


        useEffect(() => {
        if (globalProperty && globalProperty !== formData.Property) {
            setFormData(prevState => ({
                ...prevState,
                Property: globalProperty.toString()
            }));
        }
    }, [globalProperty]);
    useEffect(() => {
    if (permissions) {
        if (!isEditMode && permissions?.AddRec !== "1") {
            setIsButtonDisabled(true);
        }
        else if (isEditMode && permissions?.EditRec !== "1") {
            setIsButtonDisabled(true);
        }
        else {
            setIsButtonDisabled(false);
        }
    }
}, [permissions, isEditMode]);

  useEffect(() => {
    const fetchDataFromState = async () => {
        const state = location.state;
        if (state) {
            
            if (state.mode) {
                setMode(state.mode);
                const editMode = state.mode === 'view';
                setIsEditMode(editMode);
  
                if (editMode && permissions?.EditRec !== "1") {
                    setIsButtonDisabled(true);
                } else if (!editMode && permissions?.AddRec !== "1") {
                    setIsButtonDisabled(true);
                    toast.warning("You don't have permission to add attendance records");
                } else {
                    setIsButtonDisabled(false);
                }
            }
            
            let propId = null;
            let shiftId = null;
            let attnDt = null;
            
            if (state.propertyId) {
                propId = state.propertyId.toString();
            }
            
            if (state.shiftId) {
                shiftId = state.shiftId.toString();
            }
            
            if (state.attendanceDate) {
                attnDt = moment(state.attendanceDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
            }

            if (propId) {
                setFormData(prev => ({ ...prev, Property: propId }));
            }
            if (shiftId) {
                setFormData(prev => ({ ...prev, Shift: shiftId }));
            }
            if (attnDt) {
                setFormData(prev => ({ ...prev, DateField: attnDt }));
            }
            
            if (propId && shiftId && attnDt) {
                setTimeout(async () => {
                    setIsLoading(true);
                    setShowGrid(true);
                    try {
                        const response = await axiosInstance.post('TrnMpAttn/RetriveTrnMpAttn',
                            {
                                PropId: parseInt(propId),
                                AttnDt: attnDt,
                                ShiftId: parseInt(shiftId),
                                Flag: "R"
                            }
                        );
                        
                        if (response.data.Status === 0) {
                            setFetchedData(response.data.Data);
                            setShowGrid(true);
                        } else {
                            toast.error(response.data.Message);
                            setFetchedData([]);
                        }
                    } catch (error) {
                        console.error('Error fetching data:', error);
                        toast.error('Error fetching data. Please try again.');
                        setFetchedData([]);
                    } finally {
                        setIsLoading(false);
                    }
                }, 300);
            }
        }
    };
    
    fetchDataFromState();
}, [location.state]);


    const token = `eyJhbGciOiJIUzI1NiJ9.eyJWYWxpZElzc3VlciI6IlByYXN5c3QiLCJWYWxpZEF1ZGllbmNlIjoiUHJhc3lzdCJ9.gMMGQ74cWLoymeDv0D4c3UQKTEJSCzdkXoxlW4qF5QU`;


    const handleHomeClick = () => {
        navigate('/dashboard');
    };
    const handleLocationClick = () => {
        navigate('/operations/housekeepin', {
            //   state: {
            //     permissions: currentPermissions
            //   }
        });
    };
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };
    const totalAttendedWorkers = fetchedData.reduce((total, row) => {
        return total + (parseInt(row.AttnWorker) || 0);
    }, 0);
    const handleGetData = async () => {
        setIsLoading(true);
        try {
            const response = await axiosInstance.post('TrnMpAttn/RetriveTrnMpAttn',
                {
                    PropId: formData.Property,
                    AttnDt: formData.DateField,
                    ShiftId: formData.Shift,
                    Flag: "R"
                }
            );

            if (response.data.Status === 0) {
                setFetchedData(response.data.Data);
                setShowGrid(true);
                if (!isEditMode && permissions?.AddRec !== "1") {
                setIsButtonDisabled(true);

            } 
            else if (isEditMode && permissions?.EditRec !== "1") {
                setIsButtonDisabled(true);
              
            }
            else {
                setIsButtonDisabled(false);
            }
            } else {
                toast.error(response.data.Message);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            toast.error('Error fetching data. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleWorkerCountChange = (index, value) => {
        const updatedData = [...fetchedData];
        updatedData[index].AttnWorker = value;
        setFetchedData(updatedData);
    };

    const handleRemarkChange = (index, value) => {
        const updatedData = [...fetchedData];
        updatedData[index].Remark = value;
        setFetchedData(updatedData);
    };

    const handleSaveData = async () => {
        if (!fetchedData.length) {
            toast.error('No data to save');
            return;
        }

        try {
            const savePayload = fetchedData.map(row => ({
                PropId: parseInt(formData.Property),
                AttnDt: formData.DateField,
                ShiftId: parseInt(formData.Shift),
                HkWrkrTypeId: parseInt(row.HkWrkrTypeId),
                AttnWorker: parseInt(row.AttnWorker) || 0,
                Status: "1",
                Remark: row.Remark,
                CreatedBy: parseInt(userId)
            }));
            const response = await axiosInstance.post('TrnMpAttn/InsertTrnMpAttn', savePayload);
            if (response.data.Status === 0) {
                toast.success(response.data.Message);
            } else {
                toast.error(response.data.Message || 'Failed to save records');
            }
        } catch (error) {
            console.error('Error saving records:', error);
            toast.error('Error saving records');
        }
    };

    useEffect(() => {
        const fetchDropdownData = async () => {
            try {
                const response = await getRoomMasterdropdata({
                    Flag: "",
                    UserId: userId,
                });
                if (response?.data?.Status === 0) {
                    const dropdownItems = response.data.Data.map((item) => ({
                        id: item.PropId,
                        name: item.Name,
                    }));
                    setDropdownData(dropdownItems);
                     const state = location.state;
                const propertyIdFromState = state?.propertyId?.toString();
                if (propertyIdFromState) {
                  
                    const statePropExists = dropdownItems.find(item => 
                        item.id.toString() === propertyIdFromState
                    );
                    
                    if (statePropExists) {
                        setFormData(prev => ({ 
                            ...prev, 
                            Property: propertyIdFromState 
                        }));
                    } else if (dropdownItems.length > 0) {
                        setFormData(prev => ({ 
                            ...prev, 
                            Property: dropdownItems[0].id 
                        }));
                    }
                } else
                     if (globalProperty) {
                        const globalPropExists = dropdownItems.find(item => 
                            item.id.toString() === globalProperty.toString()
                        );
                        
                        if (globalPropExists) {
                            setFormData(prev => ({ 
                                ...prev, 
                                Property: globalProperty.toString() 
                            }));
                        } else if (dropdownItems.length > 0) {
                            setFormData(prev => ({ 
                                ...prev, 
                                Property: dropdownItems[0].id.toString() 
                            }));
                        }
                    } else if (dropdownItems.length > 0) {
                        setFormData(prev => ({ 
                            ...prev, 
                            Property: dropdownItems[0].id.toString() 
                        }));
                    }
                }
            } catch (error) {
                toast.error("Error fetching property data");
            }
        };

        fetchDropdownData();
    }, [userId,globalProperty]);

    useEffect(() => {
        const fetchShiftData = async () => {
            try {
                const response = await getShiftMasterdropdata();
                if (response?.data?.Status === 0) {
                    const dropdownItems = response.data.Data.map((item) => ({
                        id: item.ShiftId.toString(),
                        name: item.ShiftName,
                    }));
                    setShiftData(dropdownItems);
                    const state = location.state;
                const shiftIdFromState = state?.shiftId?.toString();
                
                if (shiftIdFromState) {
             
                    const stateShiftExists = dropdownItems.find(item => 
                        item.id.toString() === shiftIdFromState
                    );
                    
                    if (stateShiftExists) {
                        setFormData(prev => ({ 
                            ...prev, 
                            Shift: shiftIdFromState 
                        }));
                    } else if (dropdownItems.length > 0) {
                        setFormData(prev => ({ 
                            ...prev, 
                            Shift: dropdownItems[0].id 
                        }));
                    }
                } else if (dropdownItems.length > 0) {
                    setFormData(prev => ({ 
                        ...prev, 
                        Shift: dropdownItems[0].id 
                    }));
                }
            }
        } catch (error) {
            toast.error("Error fetching shift data");
        }
    };
        fetchShiftData();
    }, [location.state]);

    const handleOpenCalender = () => {
        setCalendarOpen(true);
    };
    const handleCalendarClose = (filters) => {
        setCalendarOpen(false);
    };

    return (
        <>
            <Box>
                <ToastContainer
                    position="top-right"
                    autoClose={2000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick={false}
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                    transition={Slide}
                />
                <Grid container spacing={1} className="">
                    <Grid
                        item
                        xs={12}
                        className="form_title"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' },
                            margin: '10px 18px',
                        }}
                    >
                        <Box sx={{ mb: 1 }}>
                            <Breadcrumbs aria-label="breadcrumb" separator="›">
                                <Link underline="hover" color="#635bff" onClick={handleHomeClick} sx={{ cursor: 'pointer' }}>
                                    Home
                                </Link>
                                <Link underline="hover" color="#635bff" onClick={handleLocationClick} sx={{ cursor: 'pointer' }}>
                                    Operations
                                </Link>
                                <Typography color="text.primary">Attendance </Typography>
                            </Breadcrumbs>
                        </Box>
                        <IconButton
                            onClick={() => navigate('/operations/housekeepin')}
                            sx={{
                                backgroundColor: '#635bff',
                                borderRadius: '50%',
                                width: 35,
                                height: 35,
                                '&:hover': {
                                    backgroundColor: '#635bff',
                                },
                                boxShadow: 3,
                            }}
                        >
                            <ArrowBackIcon sx={{ color: 'white' }} />
                        </IconButton>
                    </Grid>

                    <Grid item xs={12} sx={{ margin: '0px 20px', boxShadow: `0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)`, borderRadius: '8px' }}>
                        <Grid container spacing={1} justifyContent='center' sx={{ padding: '20px 10px' }}>
                            <Grid item xs={12} md={3} lg={3}>
                                <FormControl variant="filled" fullWidth className="custom-textfield">
                                    <InputLabel id="property-label">Property</InputLabel>
                                    <Select
                                        labelId="property-label"
                                        id="Property"
                                        name="Property"
                                        value={formData.Property}
                                        onChange={handleInputChange}
                                    >
                                        {dropdownData.map((item) => (
                                            <MenuItem key={item.id} value={item.id}>
                                                {item.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={3} lg={3}>
                                <FormControl variant="filled" fullWidth className="custom-textfield">
                                    <InputLabel id="shift-label">Shift</InputLabel>
                                    <Select
                                        labelId="shift-label"
                                        id="Shift"
                                        name="Shift"
                                        value={formData.Shift}
                                        onChange={handleInputChange}
                                    >
                                        {shiftData.map((item) => (
                                            <MenuItem key={item.id} value={item.id}>
                                                {item.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={2.5} lg={2.5}>
                                <TextField
                                    id="DateField"
                                    name="DateField"
                                    label="Date"
                                    type="date"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.DateField}
                                    onChange={handleInputChange}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    disabled={permissions?.EditRec !== "1" }
                                />
                            </Grid>
                            <Grid item xs={12} md={3.5} lg={3.5} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Button
                                    variant="contained"
                                    onClick={handleGetData}
                                    disabled={isLoading }
                                    sx={{ minWidth: '100px' }}
                                    
                                >
                                    {isLoading ? <CircularProgress size={24} /> : 'Get Data'}
                                </Button>
                                {showGrid && fetchedData.length > 0 && (
                                    <Button
                                        variant="contained"
                                        color="success"
                                        onClick={handleSaveData}

                                        disabled={isButtonDisabled}
                                        sx={{
                                            minWidth: '100px',
                                            flexWrap: 'nowrap',
                                            opacity: isButtonDisabled ? 0.6 : 1,
                                            cursor: isButtonDisabled ? 'not-allowed' : 'pointer'
                                        }}
                                    >
                                        {isEditMode ? 'Update' : 'Save Data'}
                                    </Button>
                                )}
                                <Button
                                    variant="contained"
                                    onClick={handleOpenCalender}
                                    disabled={isLoading}
                                    sx={{ minWidth: '100px' }}
                                >
                                    {isLoading ? <CircularProgress size={24} /> : 'Calender'}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>

                    {showGrid && (
                        <Grid item xs={12} sx={{ mt: 1, mx: 2 }}>
                            {isLoading ? (
                                <Box display="flex" justifyContent="center" alignItems="center" height="200px">
                                    <CircularProgress />
                                    <Typography variant="h6" sx={{ ml: 2 }}>
                                        Loading data...
                                    </Typography>
                                </Box>
                            ) : fetchedData.length > 0 ? (
                                <TableContainer
                                    component={Paper}
                                    sx={{
                                        mt: 1,
                                        boxShadow: 0,
                                        overflowX: 'auto',
                                        '& .MuiTable-root': {
                                            minWidth: '100%'
                                        }
                                    }}
                                >
                                    <Table
                                        sx={{
                                            minWidth: 400,
                                            '& .MuiTableCell-root': {
                                                border: '1px solid',
                                                borderColor: 'divider'
                                            }
                                        }}
                                        aria-label="attendance table"
                                        size="small"
                                    >
                                        <TableHead sx={{ backgroundColor: '#e3f2fd' }}>
                                            <TableRow sx={{ padding: 0, margin: 0 }}>
                                                <TableCell sx={{
                                                    padding: { xs: '1px 3px', sm: '2px 6px' },
                                                    fontWeight: 'bold',
                                                    fontSize: { xs: '0.7rem', sm: '0.8rem' },
                                                    border: '1px solid',
                                                    borderColor: 'divider',
                                                    width: { xs: '35%', sm: '25%' } 
                                                }}>
                                                    Worker Type
                                                </TableCell>
                                                 <TableCell sx={{
                                                    padding: { xs: '1px 3px', sm: '2px 6px' },
                                                    fontWeight: 'bold',
                                                    fontSize: { xs: '0.7rem', sm: '0.8rem' },
                                                    border: '1px solid',
                                                    borderColor: 'divider',
                                                    width: { xs: '25%', sm: '25%' }
                                                }}>
                                                    Plan Workers
                                                </TableCell>
                                                <TableCell sx={{
                                                    padding: { xs: '1px 3px', sm: '2px 6px' },
                                                    fontWeight: 'bold',
                                                    fontSize: { xs: '0.7rem', sm: '0.8rem' },
                                                    border: '1px solid',
                                                    borderColor: 'divider',
                                                    width: { xs: '20%', sm: '25%' }
                                                }}>
                                                    Attended Workers
                                                </TableCell>
                                                <TableCell sx={{
                                                    padding: { xs: '1px 3px', sm: '2px 6px' },
                                                    fontWeight: 'bold',
                                                    fontSize: { xs: '0.7rem', sm: '0.8rem' },
                                                    border: '1px solid',
                                                    borderColor: 'divider',
                                                    width: { xs: '35%', sm: '45%' } 
                                                }}>
                                                    Remark
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {fetchedData.map((row, index) => (
                                                <TableRow
                                                    key={index}
                                                    sx={{
                                                        padding: 0,
                                                        margin: 0,
                                                        height: '32px',
                                                        '&:hover': { backgroundColor: '#fafafa' }
                                                    }}
                                                >
                                                    <TableCell sx={{
                                                        padding: { xs: '1px 3px', sm: '2px 6px' },
                                                        margin: 0,
                                                        fontSize: { xs: '0.7rem', sm: '0.8rem' },
                                                        border: '1px solid',
                                                        borderColor: 'divider',
                                                        height: '32px',
                                                        fontWeight: 'bold',
                                                        width: { xs: '15%', sm: '20%' } 
                                                    }}>
                                                        {row.HkWrkTypeName || 'N/A'}
                                                    </TableCell>
                                                     <TableCell sx={{
                                                        padding: { xs: '1px 3px', sm: '2px 6px' },
                                                        margin: 0,
                                                        fontSize: { xs: '0.7rem', sm: '0.8rem' },
                                                        border: '1px solid',
                                                        borderColor: 'divider',
                                                        height: '32px',
                                                        fontWeight: 'bold',
                                                        width: { xs: '15%', sm: '20%' } 
                                                    }}>
                                                        {row.PlanWorker }
                                                    </TableCell>
                                                    <TableCell sx={{
                                                        padding: { xs: '1px 3px', sm: '2px 6px' },
                                                        margin: 0,
                                                        border: '1px solid',
                                                        borderColor: 'divider',
                                                        height: '32px',
                                                        width: { xs: '20%', sm: '20%' }
                                                    }}>
                                                        <TextField
                                                            type="number"
                                                            value={row.AttnWorker }
                                                            onChange={(e) => handleWorkerCountChange(index, e.target.value)}
                                                            variant="outlined"
                                                            size="small"
                                                            disabled={isButtonDisabled}
                                                            sx={{
                                                                width: { xs: '50px', sm: '70px' },
                                                                '& .MuiInputBase-root': {
                                                                    padding: 0,
                                                                    height: { xs: '22px', sm: '26px' },
                                                                    margin: 0,
                                                                    minHeight: 'auto'
                                                                },
                                                                '& .MuiInputBase-input': {
                                                                    padding: { xs: '1px 3px', sm: '2px 6px' },
                                                                    textAlign: 'center',
                                                                    fontSize: { xs: '0.7rem', sm: '0.8rem' },
                                                                    height: { xs: '22px', sm: '26px' }
                                                                },
                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                    borderWidth: '1px'
                                                                }
                                                            }}
                                                            inputProps={{
                                                                style: {
                                                                    fontWeight: 'bold',
                                                                    color: row.AttnWorker > 0 ? 'green' : 'red',
                                                                    margin: 0,
                                                                    padding: 0
                                                                }
                                                            }}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{
                                                        padding: { xs: '1px 3px', sm: '2px 6px' },
                                                        margin: 0,
                                                        border: '1px solid',
                                                        borderColor: 'divider',
                                                        height: '32px',
                                                        width: { xs: '35%', sm: '45%' } 
                                                    }}>
                                                        <TextField
                                                            value={row.Remark || ''}
                                                            onChange={(e) => handleRemarkChange(index, e.target.value)}
                                                            variant="outlined"
                                                            size="small"
                                                            placeholder="Enter remark"
                                                            disabled={isButtonDisabled}
                                                            sx={{
                                                                width: '100%',
                                                                '& .MuiInputBase-root': {
                                                                    padding: 0,
                                                                    height: { xs: '22px', sm: '26px' },
                                                                    margin: 0,
                                                                    minHeight: 'auto'
                                                                },
                                                                '& .MuiInputBase-input': {
                                                                    padding: { xs: '1px 3px', sm: '2px 6px' },
                                                                    fontSize: { xs: '0.7rem', sm: '0.8rem' },
                                                                    height: { xs: '22px', sm: '26px' }
                                                                },
                                                                '& .MuiOutlinedInput-notchedOutline': {
                                                                    borderWidth: '1px'
                                                                }
                                                            }}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            ) : (
                                !isLoading && (
                                    <Paper sx={{ p: 2, textAlign: 'center', mt: 1 }}>
                                        <Typography variant="h6" color="textSecondary">
                                            No data available. Please select filters and click "Load Data".
                                        </Typography>
                                    </Paper>
                                )
                            )}
                        </Grid>
                    )}
                    {fetchedData.length > 0 && (
                        <Box sx={{ mb: 2, p: 1, mx: 3, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
                            <Typography variant="p" sx={{ fontWeight: 'bold', color: 'primary.main', fontSize: { xs: '0.75rem', sm: '1rem' } }}>
                                Summary: Total Attended Workers - {totalAttendedWorkers}
                            </Typography>
                        </Box>
                    )}
                </Grid>
                <AttendenceCalender
                    open={calendarOpen}
                    onClose={handleCalendarClose}
                    dropdownData={dropdownData}
                    userId={userId}
                />
            </Box>
        </>
    );
};

export default Attendance;